
const Activity  = require("@/activity/Activity").default;
//const ActivityManager = require("./ActivityManager").default;
//const ActivityWorkspace  = require("./ActivityWorkspace").default;


export default class ActivityModel{
    /**
     * @param {Activity} activity 
     */
    constructor(activity = null){
        if(activity){
            this.bind(activity)
        }
        this.snapshot = "";
    }

    bind(activity){

        this.bindTime = performance.now();

        /** @type {ActivityWorkspace} */
        this.workspace = activity._getActivityWorkspace();

        /** @type {boolean} */
        this.closableInChain = false;

        /** @type {string} */
        this.componentName = "";

        /** @type {Activity} */
        this.activity = activity;

        /** @type {*} */
        this.result = null;

        /** @type {Node} */
        this.activityRootNode = null;

        /** @type {string} */
        this.persistedDisplayStyle = null;

        /** @type {*} */
        this.activityResult = undefined;

        /** @type {Promise} */
        this.activityResultPromise;

        /** @type {function} */
        this.activityResultPromiseResolve;

        /** @type {number} */
        this.id = -1;

        /** @type {boolean} */
        this.snapshotToUpdate = false;

        this.resizeCallback = () => {};

    }

    destroy(){
        this.activity = null;
        this.result = null;
        this.activityRootNode = null;
        this.resizeCallback = null;
        this.activityResult = undefined;
        this.activityResultPromise = null;
        this.activityResultPromiseResolve = null;
    }

    /**
     * @return {string}
     */
    getRoutePart(){
        return ActivityManager.camelToDash(this.activity.$options.name != undefined ? this.activity.$options.name: "a");
    }

    /**
     * @return {string}
     */
    getTitle(){
        this.updateSnapshot();
        let title = this.activity ? this.activity.getTitle() : "";
        return title;
    }

    /**
     * @return {string}
     */
    getTitleIcon(){
        this.updateSnapshot();
        return this.activity.getTitleIcon();
    }

    closeChain(force, includeActivity){
        if(this.closableInChain){
            return this.activity._getActivityWorkspace().closeChain(this, force, includeActivity);
        }
    }

    getActivityType(){
        this.updateSnapshot();
        return this.activity.getActivityType();
    }


    updateSnapshot(){
        if(!this.activity){
            return false;
        }

        let snapshot = this.activity.getActivityType() + ":"
            + this.activity.getTitleIcon() + ":"
            + this.activity.getTitle();
        if(snapshot == this.snapshot){
            return false;
        }
        this.snapshot = snapshot;
        return true;
    }
}